export function init() {
  const smakaListBlocks = document.querySelectorAll('.smakalistblock');

  if (smakaListBlocks.length) {
    smakaListBlocks.forEach(block => {
      var loadMoreBtn = block.querySelector('.js-loadmore-btn');
      loadMoreBtn.addEventListener('click', function() {
        onPaginationBtnClick(loadMoreBtn, block);
      });
    });
  }
}

const onPaginationBtnClick = (btn, block) => {
  let page = parseInt(btn.dataset.page);
  let containerPageId = parseInt(btn.dataset.containerPageId);
  let take = parseInt(btn.dataset.take);
  let url = `/api/smaka/loadmore/?containerPageId=${containerPageId}&p=${page}&itemsToTake=${take}`;

  fetch(url, {
    credentials: 'include',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
      'X-Requested-With': 'XMLHttpRequest',
    },
  })
    .then(response => response.text())
    .then(data => {
      let parsedData = JSON.parse(data);
      if (parsedData.View) {
        page++;
        btn.dataset.page = page;
        const resultList = block.querySelector('.js-resultlist');
        resultList.insertAdjacentHTML('beforeend', parsedData.View);

        if (parsedData.HideButton) {
          btn.classList.add('d-none');
        }
      } else {
        btn.classList.add('d-none');
      }
    })
    .catch(function(err) {
      console.log('Fetch Error: ', err);
    });
};
